// ======================================================================
// File: IndentFilterBar.jsx
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Filter bar UI aligned with Process Master
// - Logic unchanged
//
// ======================================================================

import React from "react";

import INDENT_STATUS from "../enums/indentStatus";
import INDENT_TYPE from "../enums/indentType";
import INDENT_SOURCE from "../enums/indentSource";

export default function IndentFilterBar({
  filters,
  onChange,
  onSearch,
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: 12,
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      {/* SEARCH */}
      <input
        className="form-control"
        style={{ maxWidth: 260 }}
        placeholder="Search indent no / remarks"
        value={filters.search}
        onChange={(e) =>
          onChange({
            ...filters,
            search: e.target.value,
          })
        }
      />

      {/* STATUS */}
      <select
        className="form-select"
        style={{ maxWidth: 160 }}
        value={filters.status}
        onChange={(e) =>
          onChange({
            ...filters,
            status: e.target.value,
          })
        }
      >
        <option value="">All Status</option>
        {Object.values(INDENT_STATUS).map(
          (status) => (
            <option key={status} value={status}>
              {status}
            </option>
          )
        )}
      </select>

      {/* TYPE */}
      <select
        className="form-select"
        style={{ maxWidth: 160 }}
        value={filters.indent_type}
        onChange={(e) =>
          onChange({
            ...filters,
            indent_type: e.target.value,
          })
        }
      >
        <option value="">All Types</option>
        {Object.values(INDENT_TYPE).map(
          (type) => (
            <option key={type} value={type}>
              {type}
            </option>
          )
        )}
      </select>

      {/* SOURCE */}
      <select
        className="form-select"
        style={{ maxWidth: 160 }}
        value={filters.indent_source}
        onChange={(e) =>
          onChange({
            ...filters,
            indent_source: e.target.value,
          })
        }
      >
        <option value="">All Sources</option>
        {Object.values(INDENT_SOURCE).map(
          (src) => (
            <option key={src} value={src}>
              {src}
            </option>
          )
        )}
      </select>

      {/* FROM DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.from_date}
        onChange={(e) =>
          onChange({
            ...filters,
            from_date: e.target.value,
          })
        }
      />

      {/* TO DATE */}
      <input
        type="date"
        className="form-control"
        style={{ maxWidth: 160 }}
        value={filters.to_date}
        onChange={(e) =>
          onChange({
            ...filters,
            to_date: e.target.value,
          })
        }
      />

      {/* SEARCH BUTTON */}
      <button
        className="btn btn-primary"
        onClick={onSearch}
      >
        Search
      </button>
    </div>
  );
}
